(function () {
    'use strict';
    angular
        .module('app.bestPerformingInfluencersReport')
        .directive('bestPerformingInfluencersReportDirective', function () {
                return {
                    controller: 'bestPerformingInfluencersReportCtrl',
                    templateUrl: 'app/measure/performanceReport/bestPerformingInfluencersReport/bestPerformingInfluencersReport.html?app_v=deployDate',
                    restrict: 'E',
                    scope: {
                    },
                    replace: true,
                    transclude: true
                };
            })
})();